<template lang="html">
  <section class="sub-main take-place column actualities master-article" v-if="article">
		<div class="cover column">
			<div class="inner">
				<img :src="article.image" alt="">
			</div>
			<div class="content column">
				<div class="tags row">
					<div class="tag" v-for="(tag, key) in article.news_tags" v-bind:key="key">
            {{ resolveTag(tag) }}
					</div>
				</div>
				<div class="title" v-html="article.title"></div>
				<div class="author column" v-if="article.author">
					<div class="ctn-profile-picture">
						<img v-img-detect :src="article.author.image" alt="">
					</div>
					<div class="column">
						<div class="name">
							Rédigé par {{ article.author.name }}
						</div>
						<div class="date">
							le {{ article.updated_at | moment('DD MMMM YYYY') }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="content-article">
			<!-- <div class="item" v-for="(item, key) in article.body" v-bind:key="key">
				<div class="title-article" v-if="item.title">
					{{ item.title}}
				</div>
				<div class="body-article" v-if="item.text">
					{{ item.text }}
				</div>
				<div class="img-article" v-if="item.img">
					<img :src="item.img">
				</div>
			</div> -->
			<div class="item" v-html="article.body"></div>
		</div>
		<!-- <div class="last-article-master">
			<div class="ctn-title row">
				<div class="title">
					Les derniers articles
				</div>
			</div>
			<div class="last-articles row">
				<div class="last-article column" v-for="(article, key) in article.lastArticles" v-bind:key="key">
					<div class="last-article-img">
						<img :src="article.img">
					</div>
					<div class="last-article-title">
						{{ article.title }}
					</div>
					<div class="last-article-content">
						{{ article.content }}
					</div>
				</div>
			</div>
		</div>-->
  </section>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	name: 'my-article',
	data () {
		return {
			article: {}
		}
	},
	mounted () {
		this.article = this.$store.getters.getArticle(this.$route.params.id)
	},
	methods: {
		resolveTag (tag) {
			if (typeof tag === 'number') {
				const gTag = this.tags.filter((t) => (t.wordpress_tag_id === tag))[0]
				if (gTag) {
					return gTag.wordpress_tag_name
				} else {
					return null
				}
			} else {
				return tag.tags.wordpress_tag_name
			}
		}
	},
	computed: {
		...mapGetters({
			tags: 'tags'
		})
	}
}
</script>

<style lang="scss" scoped>

.ctn-profile-picture {
	background-color: white;
}
</style>



// WEBPACK FOOTER //
// article.vue?d479773a